import { useRef } from 'react'

import Button from 'Root/App/Button'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { AppSumoPageProps } from 'pages/saaszilla'

const CheckRegistration = () => {
  return (
    <span className="flex flex-col justify-center items-center gap-3">
      <Paragraph>Welcome! Are you already registered on Taylora?</Paragraph>
      <Paragraph>
        If NO, you will be sent to the Taylora registration form and then you
        will be brought back here for the code redeem.
      </Paragraph>
      <span className="flex justify-center gap-6">
        <Button
          className="w-full bg-gray-900"
          anchor
          to="/login?returnUrl=saaszilla"
        >
          Yes
        </Button>
        <Button
          className="w-full bg-gray-900"
          anchor
          to="/registration?returnUrl=saaszilla"
        >
          No
        </Button>
      </span>
    </span>
  )
}

const AddCoupon = ({ accessToken, userEmail }: AppSumoPageProps) => {
  const router = useRouter()
  const couponRef = useRef<HTMLInputElement>(null)
  const errorFieldRef = useRef<HTMLSpanElement>(null)

  const handleSubmit = (e) => {
    e.preventDefault()

    const bodyRequest = {
      coupon: couponRef.current.value,
    }

    const addCoupon = async () => {
      const response = await fetch(
        process.env.NEXT_PUBLIC_BASE + '/_/redeem-coupon',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(bodyRequest),
        }
      )

      const data = await response.json()

      if (response.ok) {
        router.push('/')
      } else {
        errorFieldRef.current.textContent = data
      }
    }

    addCoupon()
  }

  return (
    <div className="flex flex-col p-4 gap-6 text-center h-screen justify-center items-center">
      <Image
        src="/taylora-saaszilla-icon.png"
        alt="test"
        width={300}
        height={200}
        className="w-auto h-auto"
        priority
      />
      <Title>Redeem SaasZilla Code</Title>
      {userEmail ? (
        <div className="flex flex-col gap-3 w-full sm:w-1/3 p-3">
          <span className="text-gray-500 font-normal max-w-xl">
            You will redeem a coupon for:{' '}
            <span className="text-gray-900 font-bold">{userEmail}</span>
          </span>
          <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
            <span className="flex flex-col gap-1">
              <input
                id="coupon"
                className="p-1 rounded-md outline-none border-1 border-black focus:ring-purple-500 focus:ring-2 focus:border-transparent"
                ref={couponRef}
                type="text"
                placeholder="Insert your SaasZilla code"
                required
              />
            </span>

            <span
              id="error-field"
              ref={errorFieldRef}
              className="text-red-500 font-semibold"
            ></span>

            <Button type="submit" className="bg-gray-900">
              Redeem code
            </Button>
          </form>
        </div>
      ) : (
        <CheckRegistration />
      )}
    </div>
  )
}

export default AddCoupon
